import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MigrationTable from './MigrationTable';
import MigrationModal from './MigrationModal';
import './MainContent.css';
import { MigrationFormData, MigrationData } from '../types';
import orgService from '../services/orgService';

const MainContent: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchTerm(e.target.value);
  };

  const handleInitiateMigration = (): void => {
    setIsModalOpen(true);
  };

  const handleCloseModal = (wasCompleted?: boolean): void => {
    setIsModalOpen(false);
    // If migration was completed, trigger a refresh of the migration history
    if (wasCompleted) {
      setRefreshTrigger(prev => prev + 1);
    }
  };

  const handleSubmitMigration = (formData: MigrationFormData): void => {
    console.log('Migration submitted:', formData);
    // Handle migration submission logic here
  };

  const handleMigrationClick = (migration: MigrationData): void => {
    navigate(`/dashboard/report/${migration.id}`, { state: { migration } });
  };

  // Check if user role is "user" or "administrator" to disable the button
  const shouldDisableInitiateButton = (): boolean => {
    const role = orgService.getRole();
    return role === 'user' || role === 'administrator';
  };

  return (
    <div className="main-content">
      {/* Action Bar - Outside white background */}
      <div className="action-bar">
        <h1 className="page-title">Manage Migrations</h1>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="Search ..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
          <button className="search-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <button 
          className="initiate-button" 
          onClick={handleInitiateMigration}
          disabled={shouldDisableInitiateButton()}
        >
          Initiate New Migration
        </button>
      </div>

      {/* Migration Table - Inside white background */}
      <div className="table-container">
        <MigrationTable onMigrationClick={handleMigrationClick} searchTerm={searchTerm} refreshTrigger={refreshTrigger} />
      </div>

      {/* Migration Modal */}
      <MigrationModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitMigration}
      />
    </div>
  );
};

export default MainContent;
